<div class="igntr-theme h-screen flex flex-col">
  <div
    class="px-4 py-3 border-b border-slate-100 flex items-start justify-between flex-shrink-0"
  >
    <div>
      <div class="text-[12px] uppercase tracking-[0.1em] !text-slate-400">
        {{ "new" | transloco }}
      </div>
      <div class="text-[14px] font-semibold !text-slate-900 mt-0.5">
        {{ "setMsGraphOptions" | transloco }}
      </div>
    </div>
    <button
      class="p-2 rounded-lg hover:!bg-slate-100 !text-slate-500 inline-flex"
      type="button"
      (click)="onCloseModal.emit()"
    >
      <igntr-icon name="close"></igntr-icon>
    </button>
  </div>
  <form
    *ngIf="Form"
    [formGroup]="Form"
    enctype="multipart/form-data"
    class="flex-1 overflow-y-auto min-h-0"
  >
    <div class="p-6 space-y-4">
      <div [appValidateState]="Form.get('title')">
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          {{ "title" | transloco }}
        </div>
        <input
          formControlName="title"
          type="text"
          class="w-full px-3 py-2 rounded-lg border border-slate-200 focus:border-slate-400 outline-none text-[14px]"
          placeholder="{{ 'title' | transloco }}"
          autocomplete="off"
        />
      </div>

      <div [appValidateState]="Form.get('msGraphClientId')">
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          {{ "msGraphClientId" | transloco }}
        </div>
        <input
          formControlName="msGraphClientId"
          type="text"
          class="w-full px-3 py-2 rounded-lg border border-slate-200 focus:border-slate-400 outline-none text-[14px]"
          placeholder="{{ 'msGraphClientId' | transloco }}"
          autocomplete="off"
        />
      </div>

      <div
        class="form-group form-floating mb-3"
        [appValidateState]="Form.get('msGraphClientSecret')"
      >
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          {{ "msGraphClientSecret" | transloco }}
        </div>
        <input
          formControlName="msGraphClientSecret"
          type="text"
          class="w-full px-3 py-2 rounded-lg border border-slate-200 focus:border-slate-400 outline-none text-[14px]"
          placeholder="{{ 'msGraphClientSecret' | transloco }}"
          autocomplete="off"
        />
      </div>

      <div
        class="form-group form-floating mb-3"
        [appValidateState]="Form.get('msGraphFromMail')"
      >
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          {{ "msGraphFromMail" | transloco }}
        </div>
        <input
          formControlName="msGraphFromMail"
          type="text"
          class="w-full px-3 py-2 rounded-lg border border-slate-200 focus:border-slate-400 outline-none text-[14px]"
          placeholder="{{ 'msGraphFromMail' | transloco }}"
          autocomplete="off"
        />
      </div>

      <div
        class="form-group form-floating mb-3"
        [appValidateState]="Form.get('msGraphTenantId')"
      >
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          {{ "msGraphTenantId" | transloco }}
        </div>
        <input
          formControlName="msGraphTenantId"
          type="text"
          class="w-full px-3 py-2 rounded-lg border border-slate-200 focus:border-slate-400 outline-none text-[14px]"
          placeholder="{{ 'msGraphTenantId' | transloco }}"
          autocomplete="off"
        />
      </div>

      <div class="form-group form-floating mb-3" *ngIf="showDriveTree">
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          SharePoint Site
        </div>
        <p-select
          [ngModelOptions]="{ standalone: true }"
          [style]="{ width: '100%' }"
          [options]="sitesStruct"
          optionLabel="siteName"
          optionValue="siteId"
          (onChange)="onSiteChange($event.value)"
          placeholder="Select site"
          [(ngModel)]="selectedSite"
          class="w-full rounded-lg border border-slate-200 focus:border-slate-400 outline-none text-[14px]"
        >
        </p-select>
      </div>

      <div class="form-group form-floating mb-3" *ngIf="showDriveTree">
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          SharePoint Drive
        </div>
        <p-select
          [ngModelOptions]="{ standalone: true }"
          [style]="{ width: '100%' }"
          [options]="drivesStruct"
          optionLabel="driveName"
          optionValue="driveId"
          (onChange)="onDriveChange($event.value)"
          placeholder="Select drive"
          [(ngModel)]="selectedDrive"
          class="w-full rounded-lg border border-slate-200 focus:border-slate-400 outline-none text-[14px]"
        >
        </p-select>
      </div>

      <div class="form-group form-floating mb-3" *ngIf="showDriveTree">
        <div class="text-[14px] font-medium !text-slate-700 mb-1 block">
          Start Folder Path
        </div>

        <p-tree
          [value]="folderNodes"
          selectionMode="single"
          [(selection)]="selectedNode"
          (onNodeSelect)="onFolderSelect($event)"
        >
        </p-tree>
      </div>
      <div
        class="flex items-center gap-2 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
      >
        <input
          formControlName="useForSystemMails"
          class="w-[13px] ng-untouched ng-pristine ng-valid"
          type="checkbox"
        />
        <div class="text-[14px] font-medium !text-slate-700 block">
          {{ "useForSystemMails" | transloco }}
        </div>
      </div>
      <div
        class="flex items-center gap-2 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
      >
        <input
          formControlName="customBusinessCard"
          class="w-[13px] ng-untouched ng-pristine ng-valid"
          type="checkbox"
        />
        <div class="text-[14px] font-medium !text-slate-700 block">
          {{ "customBusinessCard" | transloco }}
        </div>
      </div>
      <div
        class="flex items-center gap-2 py-1.5 rounded-md hover:!bg-slate-50 cursor-pointer"
      >
        <input
          formControlName="useSharePointForDataRoom"
          class="w-[13px] ng-untouched ng-pristine ng-valid"
          type="checkbox"
        />
        <div class="text-[14px] font-medium !text-slate-700 block">
          Use SharePoint for DataRoom
        </div>
      </div>
      <p-editor
        class="editor"
        [placeholder]="'customBusinessCardContent'"
        [style]="{ minHeight: '150px' }"
        formControlName="customBusinessCardContent"
        *ngIf="Form.get('customBusinessCard')?.value"
      >
        <ng-template pTemplate="header">
          <app-editor [allowImageInsert]="true"></app-editor
        ></ng-template>
      </p-editor>
      <div class="flex gap-4">
        <button
          [disabled]="Form!.pristine"
          (click)="formResult()"
          class="px-2.5 py-1.5 rounded-lg bg-[--primary-color] text-white text-[14px] font-medium"
        >
          {{ "save" | transloco }}
        </button>

        <button
          (click)="onCloseModal.emit()"
          class="px-2.5 py-1.5 rounded-lg !bg-slate-900 text-white text-[14px] font-medium"
        >
          {{ "Cancel" | transloco }}
        </button>
      </div>
    </div>
  </form>
</div>

<p-progress-spinner
  [ngStyle]="{
    'justify-content': 'center',
    'align-items': 'center',
    opacity: '0.3',
    height: '100%',
    width: '100%',
    background: 'rgba(0, 0, 0, 0.7)',
    left: '0',
    top: '0',
    'z-index': '9999',
    position: 'absolute',
    display: 'flex',
  }"
  *ngIf="loading"
  ariaLabel="loading"
/>
